import { Grid, Typography } from "@material-ui/core";
import Chart from "react-apexcharts";
import NoData from "../BillsFilter/NotFound";

const ProjectAbstract = ({ devices, project, tags, types }) => {
  let availbleTypes = [];
  types.forEach((type) =>
    devices.filter(
      (device) =>
        device.water_meter_type_info.water_meter_type_name ===
        type.water_meter_type_name
    ).length > 0
      ? availbleTypes.push(type)
      : null
  );
  const getLength = (arrayIndex, arrayName) => {
    let filtered = [];
    if (arrayName === "tags") {
      filtered = devices.filter(
        (device) =>
          device.water_meter_tag_info.water_meter_tag_id === tags[arrayIndex].id
      );
    } else {
      filtered = devices.filter(
        (device) =>
          device.water_meter_type_info.water_meter_type_name ===
          availbleTypes[arrayIndex].water_meter_type_name
      );
    }
    return filtered.length;
  };
  //tags
  const tagChartOptions = {
    labels: tags.map((tag) => tag.name),
  };
  let tagChartSeries = [];
  tags.forEach((tag, idx) => tagChartSeries.push(getLength(idx, "tags")));
  //types
  const typeChartOptions = {
    labels: availbleTypes.map((type) => type.water_meter_type_name),
  };
  let typeChartSeries = [];
  availbleTypes.forEach((type, idx) =>
    typeChartSeries.push(getLength(idx, "types"))
  );
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ margin: "0 auto", textAlign: "center", padding: "20px 0" }}
      >
        <Typography id="transition-modal-title" variant="h5" component="h2">
          {project.water_meter_project_name}
        </Typography>
      </Grid>
      {devices.length > 0 ? (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{
              padding: "20px 15px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="h6">
              {`تعداد کل دستگاه ها : ${devices.length} عدد`}
            </Typography>
            <div
              style={{
                maxWidth: "400px",
                width: "100%",
              }}
            >
              <Chart
                options={tagChartOptions}
                series={tagChartSeries}
                type="pie"
                width="100%"
              />
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{
              padding: "20px 15px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="h6">
              انواع دستگاه در این پروژه
            </Typography>
            <div
              style={{
                maxWidth: "400px",
                width: "100%",
              }}
            >
              <Chart
                options={typeChartOptions}
                series={typeChartSeries}
                type="donut"
                width="100%"
              />
            </div>
          </Grid>
        </>
      ) : (
        <div style={{ margin: "0 auto" }}>
          <NoData message={"دستگاهی در این پروژه موجود نیست"} />
        </div>
      )}
    </>
  );
};
export default ProjectAbstract;
